import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Schema } from './components/round-form.schema';
import { useCreateRoundMutation } from '../mutations';
import { RoundForm } from './components/round-form';
import { useNavigate } from 'react-router';
import { Fragment } from 'react/jsx-runtime';
import { toast } from 'react-toastify';

export function Page() {
  const mutation = useCreateRoundMutation();
  const navigate = useNavigate();

  async function onSubmit(payload: Schema) {
    await toast.promise(mutation.mutateAsync(payload), {
      success: 'Serieomgången har skapats',
      pending: 'Skapar serieomgång...',
    });
    navigate(-1);
  }

  return (
    <Fragment>
      <PageLayout.Heading text="Skapa serieomgång" />

      <PageLayout.Section>
        <RoundForm onSubmit={onSubmit} isLoading={mutation.isPending} mode="create" />
      </PageLayout.Section>
    </Fragment>
  );
}
